export default [
  {
    path: '/login',
    name: 'auth-login',
    component: () => import('@/views/auth/login.vue'),
    meta: {
      layout: 'single',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/forgot-password',
    name: 'auth-forgot',
    component: () => import('@/views/auth/forgotpassword.vue'),
    meta: {
      layout: 'single',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/auth/register.vue'),
    meta: {
      layout: 'single',
      resource: 'Auth',
      redirectIfLoggedIn: true,
    },
  },
]
